import { type ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

// https://ionic.io/ionicons type in copy -> in outline section
const CopyIcon = ({ className, ...props }: ComponentPropsWithoutRef<"svg">) => {
  const defaultClassnames =
    "icon icon-ionicons icon-ionicons-copy h-2.75 w-2.75";

  return (
    <svg
      viewBox="0 0 512 512"
      className={twMerge(defaultClassnames, className)}
      fill="currentColor"
      stroke="currentColor"
      {...props}
    >
      <path
        fill="none"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M185 128 H407 A57 57 0 0 1 464 185 V407 A57 57 0 0 1 407 464 H185 A57 57 0 0 1 128 407 V185 A57 57 0 0 1 185 128 z"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"
      />
    </svg>
  );
};

export default CopyIcon;
